import { dasherizeParts, FlagState, Stat } from '@timing71/common';

const SECTOR_STATS = [
  Stat.S1,
  Stat.BS1,
  Stat.S2,
  Stat.BS2,
  Stat.S3,
  Stat.BS3,
  Stat.S4,
  Stat.BS4,
  Stat.S5,
  Stat.BS5,
];

const SESSION_FLAG_MAP = {
  'STOP': FlagState.CHEQUERED,
  'CHECKERED FLAG': FlagState.CHEQUERED,
  'GREEN FLAG': FlagState.GREEN,
  'RED FLAG': FlagState.RED,
  'SAFETY CAR': FlagState.SC,
  'SLOW ZONE': FlagState.SLOW_ZONE
}

const mapFlag = (flag) => {
  if (flag && flag.startsWith('YELLOW')) {
    return FlagState.YELLOW;
  }
  return SESSION_FLAG_MAP[flag] || FlagState.NONE;
}

const getSectorCount = (state) => (state.config?.inters || []).filter(i => i.type === 0 && (i.distance > 0 || i.endLoop > 0)).length;

export const createManifest = (state) => {

  const intermediateCount = getSectorCount(state);
  const sectorCols = SECTOR_STATS.slice(0, intermediateCount * 2);

  return {
    name: state.event?.name || 'ITS Live',
    description: dasherizeParts(
      state.raceInfo?.folder_name,
      state.raceInfo?.race_name
    ),
    colSpec: [
      Stat.NUM,
      Stat.STATE,
      Stat.DRIVER,
      Stat.TEAM,
      Stat.CAR,
      Stat.LAPS,
      Stat.GAP,
      Stat.INT,
      ...sectorCols,
      Stat.LAST_LAP,
      Stat.BEST_LAP,
      Stat.PITS
    ]
  }
}

export const getState = (state) => {
  return {
    cars: mapCars(state),
    session: mapSession(state)
  };
}

const mapSession = (state) => {

  const now = Date.now() / 1000;
  const offset = state.raceInfo?.race_flag === 'READY' ? 0 : now - state.session?.last_update || 0;

  const session = {
    flagState: mapFlag(state.raceInfo?.race_flag),
    timeElapsed: (state.raceInfo?.elapsed_time || 0) / 1000 + offset,
    timeRemain: (state.raceInfo?.remaining_time || 0) / 1000 - offset,
  }

  if (state.raceInfo?.remaining_lap > 0) {
    session.lapsRemain = state.raceInfo?.remaining_lap;
  }

  return session;
}

const mapCars = (state) => {
  return state.ranking.ranking.filter(c => c.pos >= 0).map(mapCar(state));
}

const mapCar = (state) => {
  const intermediateCount = getSectorCount(state);

  const getSectorCols = (car) => {
    const sectorCols = [];

    for (let i = 0; i < intermediateCount; i++) {

      const currentSector = car[`inter_${i+1}`];
      const bestSector = car[`best_inter_${i+1}`];

      const isBOA = bestSector === state.ranking?.boa[i + 1];

      sectorCols.push([
        currentSector && currentSector > 0 ? currentSector / 1000 : null,
        currentSector === bestSector ? isBOA ? 'sb' : 'pb' : ''
      ]);
      sectorCols.push([
        bestSector && bestSector > 0 ? bestSector / 1000 : null,
        isBOA ? 'sb' : 'old'
      ]);
    }

    return sectorCols;
  }

  const boaTime = state.ranking.boaTime;

  return (car) => {

    const last = car.lap_time;
    const best = car.best_time;

    const sectorCols = getSectorCols(car);

    let llFlag = '';
    if (best === last) {
      llFlag = 'pb';

      if (last === boaTime) {
        if (sectorCols.length > 1 && sectorCols[sectorCols.length - 2][0] !== null) {
          llFlag = 'sb-new';
        }
        else {
          llFlag = 'sb';
        }
      }
    }

    return [
      car.number,
      mapCarState(car, last === -1),
      car.driver_names[car.current_driver],
      car.club,
      car.vehicle || car.model,
      car.total_lap,
      car.gap_first !== '-' ? car.gap_first : null,
      car.gap_prev !== '-' ? car.gap_prev : null,
      ...sectorCols,
      [
        last && last > 0 ? last / 1000 : null,
        llFlag
      ],
      [
        best && best > 0 ? best / 1000 : null,
        best === boaTime ? 'sb' : 'old'
      ],
      car.total_pit_stop
    ];
  }
}

const STATE_IMAGES_MAP = {
  '_CheckeredFlag': 'FIN',
  '_PitIn': 'PIT',
  '_PitOut': 'OUT',
  '_MaximumTime': 'STOP',
}

const STATE_NUMBERS_MAP = {
  1: 'LC',
  2: 'N/C',
  3: 'NT',
  4: 'LT1',
  5: 'N/S',
  6: 'N/C',
  7: 'N/C',
  8: 'N/C',
  9: 'DNF',
  10: 'RET',
  11: 'DSQ',
  12: 'DSQ'
}

const mapCarState = (car, lastLapInPits=false) => {
  const state = car.status;
  const state_img = car.status_img;

  return STATE_IMAGES_MAP[state_img] || STATE_NUMBERS_MAP[state] || (lastLapInPits ? 'OUT' : 'RUN');

};
